import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ id, title, children }) => (
  <section id={id} className="whitepaper-section">
    <h2 className="whitepaper-section-title">{title}</h2>
    <div className="whitepaper-section-content">{children}</div>
    <div className="whitepaper-section-divider"></div>
  </section>
);

const Whitepaper = () => {
  const lastUpdated = "2025-08-28";
  
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="whitepaper-page">
      <main className="whitepaper-main">
        <div className="whitepaper-container">
          {/* Header */}
          <header className="whitepaper-header">
            {/* <h1 className="whitepaper-title">NFT-People: Micro Whitepaper</h1> */}
            <p className="whitepaper-version">Version 1.0 • Last updated {lastUpdated}</p>

            {/* Actions */}
            <div className="whitepaper-actions">
              {/* <button
                onClick={handlePrint}
                className="whitepaper-btn whitepaper-btn--print"
              >
                Print / Save PDF
              </button> */}
              <Link
                to="/#team"
                className="whitepaper-btn whitepaper-btn--team"
              >
                Meet the Makers
              </Link>
            </div>
          </header>

          {/* Pixel-style Document */}
          <div className="whitepaper-document">
            <div className="whitepaper-document-content">
              <p>
                We are NFT-People: an artist and a developer who met on Tezos in June 2021 and set out to prove that simple pixels can carry lasting stories. We launched the first generative pixel-art PFP collection on Tezos—a 5,000-piece series created to be open, fair, and accessible—and have treated it since as a living artwork rather than a momentary drop. Our ethos is straightforward: build slowly, keep things honest, and let the work speak over time. We value equal access over hype, permanence over trends, and the quiet compounding of culture that comes from people making, collecting, and imagining together.
              </p>
              <p>
                This whitepaper is not a roadmap of promises; it is a statement of intent. We will continue to maintain the collection, care for its home on the web, and evolve the project with thoughtful additions when they serve the art and its community. No seasons, no resets—just continuity. If you're here, you are part of the piece: discovering, trading, remixing, and carrying these pixels into new contexts. We will keep building, the work will keep breathing, and the art will continue.
              </p>
            </div>
          </div>

       
        </div>
      </main>
    </div>
  );
};

export default Whitepaper;

